import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { getGameRNG } from '../core/rng';

export const WeaponAirstrike: WeaponDefinition = {
  id: 'airstrike',
  name: 'Airstrike',
  icon: 'airstrke.png',
  category: 'strike',
  maxAmmo: 1,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: false,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, world, target } = ctx;

    if (!target) {
      return {
        success: false,
        message: 'Select a target location',
      };
    }

    const missileCount = 5;
    const spacing = 50;
    const planeSpeed = 350;
    const dropDelay = 0.12;

    const flyingLeft = getGameRNG().next() > 0.5;
    const planeVx = flyingLeft ? -planeSpeed : planeSpeed;

    const startX = flyingLeft
      ? target.x + missileCount * spacing
      : target.x - missileCount * spacing;
    const startY = -80;

    for (let i = 0; i < missileCount; i++) {
      const dropTime = i * dropDelay;
      const dropX = startX + planeVx * dropTime;
      const dropY = startY;

      const missile = new Projectile({
        x: dropX,
        y: dropY,
        vx: planeVx * 0.4,
        vy: 150,
        type: 'bazooka',
        timer: -1,
        bounceH: 0,
        bounceV: 0,
        windAffected: true,
        explosionRadius: 35,
        maxDamage: 30,
        ownerId: worm.id,
      });

      setTimeout(() => {
        world.addEntity(missile);
      }, dropTime * 1000);
    }

    return {
      success: true,
      entities: [],
      message: 'Airstrike incoming!',
    };
  },
};
